// Definimos la interfaz que esperamos encontrar inyectada por el WebView (Android nativo o React Native)
declare global {
    interface Window {
        // Interfaz para Android nativo (addJavascriptInterface)
        Android?: {
            postMessage: (message: string) => void;
        };
        // Interfaz estándar para React Native WebView
        ReactNativeWebView?: {
            postMessage: (message: string) => void;
        };
    }
}

/**
 * Envía un mensaje a la aplicación nativa (Android o React Native).
 */
export const sendToNative = (action: string, payload: any = {}) => {
    try {
        const message = JSON.stringify({ action, payload });

        // 1. Intentar enviar a React Native (iOS/Android usando react-native-webview)
        if (typeof window !== 'undefined' && window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(message);
            return;
        }

        // 2. Intentar enviar a Android Nativo (Legacy/Custom Interface)
        if (typeof window !== 'undefined' && window.Android && window.Android.postMessage) {
            window.Android.postMessage(message);
            return;
        }

    } catch (error) {
        console.error("Error al enviar mensaje a nativo:", error);
    }
};

// Mantenemos retrocompatibilidad por si se usó el nombre anterior
export const sendToAndroid = sendToNative;
